import React, { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext";
import "./CreatorAccessButton.scss";

/**
 * A persistent entry point for users who have not enabled creator access yet.
 * It belongs in AppLayout so its position and behaviour are identical on every
 * regular, authenticated page.
 */
const CreatorAccessButton = () => {
  const { isCreator, becomeCreator } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (isCreator) return null;

  const handleClick = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    const result = await becomeCreator();
    setIsSubmitting(false);

    if (result.success) {
      toast.success("You're now a creator! You can create assessments.");
    } else {
      toast.error("Couldn't enable creator access. Please try again.");
    }
  };

  return (
    <button
      type="button"
      className="creator-access-button"
      onClick={handleClick}
      disabled={isSubmitting}
      aria-label="Become a Creator"
      title="Enable creator access"
    >
      <Sparkles size={18} aria-hidden="true" />
      <span>{isSubmitting ? "Enabling..." : "Become a Creator"}</span>
    </button>
  );
};

export default CreatorAccessButton;
